import { render, staticRenderFns } from "./show-composition.vue?vue&type=template&id=118c39ea&"
import script from "./show-composition.vue?vue&type=script&lang=js&"
export * from "./show-composition.vue?vue&type=script&lang=js&"
import style0 from "./show-composition.vue?vue&type=style&index=0&lang=sass&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSheet,VSimpleTable})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('118c39ea')) {
      api.createRecord('118c39ea', component.options)
    } else {
      api.reload('118c39ea', component.options)
    }
    module.hot.accept("./show-composition.vue?vue&type=template&id=118c39ea&", function () {
      api.rerender('118c39ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/show-composition.vue"
export default component.exports